/* Copyright (C) nexleader - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written for nexleader <myipsat.com>, 2016-2018
 */

/*global angular*/
import { BsModalService } from 'ngx-bootstrap/modal';
import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-nexleader-about-team-report-domains-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './about-team-report-domains-modal.component.html',
})
export class NexleaderAboutTeamReportDomainsModalComponent {
  /**
   * users
   *
   * An array of users that represents those that have imported their MPP data
   */
  @Input() users: any;
  constructor(private bsModalService: BsModalService) { }

  /**
   * close
   *
   * A close callback function to use
   *
   * ex: someFn()
   */
  close() {
    this.bsModalService.hide();
  }
}
